"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.timeConverter = undefined;

var _leftPad = require("left-pad");

var _leftPad2 = _interopRequireDefault(_leftPad);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var timeConverter = exports.timeConverter = function timeConverter(a) {
  a = new Date(a);
  var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  var month = months[a.getMonth()];
  var date = a.getDate();
  var hour = (0, _leftPad2.default)(a.getHours(), 2, "0");
  var min = (0, _leftPad2.default)(a.getMinutes(), 2, "0");
  var sec = (0, _leftPad2.default)(a.getSeconds(), 2, "0");
  return month + " " + date + " " + hour + ":" + min + ":" + sec;
};
//# sourceMappingURL=time.js.map


//////////////////
// WEBPACK FOOTER
// ../wheelhouse-core/dist/util/time.js
// module id = 256
// module chunks = 0